import styled from "styled-components";
import { Icon } from "../../../components/icons";
import { colours } from "../../../styles/colours";

const CheckMark = styled(Icon).attrs({ type: "veryGoodCheck" })`
  width: 7em;
  height: 7em;
`;
const CheckMarkWrapper = styled.div`
  margin: 0 auto 2em;
  padding: 3em;
  border: 6px solid ${colours.green};
  border-radius: 100%;
  display: inline-block;
`;

const Container = styled.div`
  text-align: center;
  padding: 2em;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SuccessSignUp = ({ merchant }: { merchant: boolean }) => {
  return (
    <Container>
      <CheckMarkWrapper>
        <CheckMark />
      </CheckMarkWrapper>
      <div>
        Your Sekuritance {merchant ? "Business" : "Personal"} Account has been
        created. Please check your inbox (check your spam folder too) to
        activate your account.
      </div>
    </Container>
  );
};
